import axios from "./axios";

function getCodPointSale() {
  const codPointSale = localStorage.getItem("codPointSale");
  return codPointSale || null;
}

function withCodPointSaleParams(params = {}) {
  const codPointSale = getCodPointSale();

  if (!codPointSale) {
    return params;
  }

  return {
    ...params,
    codPointSale,
  };
}

function withCodPointSaleBody(data = {}) {
  const codPointSale = getCodPointSale();

  if (!codPointSale) {
    return data;
  }

  return {
    ...data,
    codPointSale,
  };
}

export default {
  getStatus() {
    return axios({
      method: "GET",
      url: "cash-opening/status",
      headers: { "content-type": "application/json" },
      params: withCodPointSaleParams(),
    }).then((response) => response.data);
  },

  getOpenings(params = {}) {
    return axios({
      method: "GET",
      url: "cash-opening/openings",
      headers: { "content-type": "application/json" },
      params,
    }).then((response) => response.data);
  },

  getOpeningSummary(openingId) {
    return axios({
      method: "GET",
      url: `cash-opening/openings/${openingId}/summary`,
      headers: { "content-type": "application/json" },
    }).then((response) => response.data);
  },

  getCloseSummary(params = {}) {
    return axios({
      method: "GET",
      url: "cash-opening/close-summary",
      headers: { "content-type": "application/json" },
      params: withCodPointSaleParams(params),
    }).then((response) => response.data);
  },

  getControls(params = {}) {
    return axios({
      method: "GET",
      url: "cash-opening/controls",
      headers: { "content-type": "application/json" },
      params,
    }).then((response) => response.data);
  },

  getInternalUsers() {
    return axios({
      method: "GET",
      url: "cash-opening/internal-users",
      headers: { "content-type": "application/json" },
    }).then((response) => response.data);
  },

  openCash(data) {
    return axios({
      method: "POST",
      url: "cash-opening/open",
      headers: { "content-type": "application/json" },
      data: withCodPointSaleBody(data),
    }).then((response) => response.data);
  },

  closeCash(data) {
    return axios({
      method: "PUT",
      url: "cash-opening/close",
      headers: { "content-type": "application/json" },
      data: withCodPointSaleBody(data),
    }).then((response) => response.data);
  },

  reopenCash(data) {
    return axios({
      method: "PUT",
      url: "cash-opening/reopen",
      headers: { "content-type": "application/json" },
      data,
    }).then((response) => response.data);
  },

  createControl(data) {
    return axios({
      method: "POST",
      url: "cash-opening/controls",
      headers: { "content-type": "application/json" },
      data: withCodPointSaleBody(data),
    }).then((response) => response.data);
  },
};
